import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';


class AgentAvatar extends Component {

    constructor(props) {

        super(props);

    }


    render() {
        const { t } = this.props;
        return (
            <div className={"avatar mr-0 " + (this.props.user.status==1 ? 'avatar-online' : 'avatar-offline')}>
                <div className="letter-avatar ">
                    {this.props.user.no_avatar == 1 &&
                    <span>{this.props.user.first_letter}</span>
                    }
                    {this.props.user.no_avatar == 0 &&
                    <span><img src={this.props.user.avatar}/></span>
                    }
                </div>
            </div>

        );
    }
}

export default withTranslation()(AgentAvatar);
